import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { UnauthedPage } from 'components/unauthed-page';
import { useStore } from 'models/Provider';

type SuccessProps = {
  isReset?: boolean;
};

export const PasswordSuccess = ({ isReset = false }: SuccessProps) => {
  const { t } = useStore();

  const heading = isReset ? t('pwsuccess.reset.heading') : t('pwsuccess.set.heading');

  return (
    <UnauthedPage>
      <Stack space={6}>
        <Stack space={2}>
          <Text font="heading1" text={heading} center />
          <Text font="regular16" color="purple80" text={t('pwsuccess.instruction')} center />
        </Stack>
        <Button as="a" text={t('pwsuccess.signin')} href="/signin" variant="primary-blue" />
      </Stack>
    </UnauthedPage>
  );
};
